import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const relatedCourses = [{
  title: "Técnico Electricista",
  description: "Aprende las bases y técnicas avanzadas de la electricidad domiciliaria e industrial con enfoque práctico.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/course_electrical_technician.png",
  href: "/ElectricalTechnicianPage"
}, {
  title: "Barbería Profesional",
  description: "Domina las últimas tendencias en cortes masculinos, perfilado de barba y cuidado capilar integral.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/course_barbershop.png",
  href: "/BarbershopPage"
}, {
  title: "Técnico en Energía Solar",
  description: "Fórmate en la instalación, mantenimiento y diseño de sistemas de paneles solares y energías renovables.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/course_solar_energy.png",
  href: "/SolarEnergyTechnicianPage"
}];
export default function CursosRelacionados() {
  return <section id="cursos-relacionados" className="bg-background py-[120px]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-sans text-3xl font-extrabold tracking-tight text-foreground md:text-4xl">
            Cursos Relacionados
          </h2>
          <p className="mt-4 font-sans text-lg text-muted-foreground">
            Explora otras opciones formativas que podrían impulsar tu carrera profesional.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {relatedCourses.map((course, i) => <div data-index={i} key={i} className="h-full">
              <Card className="flex h-full flex-col overflow-hidden rounded-[24px] border border-border/50 bg-background/60 shadow-lg backdrop-blur-md transition-all hover:shadow-xl">
                <div className="relative h-56 w-full shrink-0 overflow-hidden">
                  <img src={course.image} alt={course.title} className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
                  {}
                  <div className="absolute inset-0 bg-primary/20 mix-blend-multiply"></div>
                </div>

                <CardHeader className="px-8 pt-8 pb-4">
                  <CardTitle className="font-sans text-xl font-extrabold leading-tight text-foreground">
                    {course.title}
                  </CardTitle>
                </CardHeader>

                <CardContent className="flex-grow px-8 pb-6">
                  <p className="font-sans text-base leading-relaxed text-muted-foreground">
                    {course.description}
                  </p>
                </CardContent>

                <CardFooter className="mt-auto px-8 pb-8 pt-0">
                  <Button asChild variant="ghost" className="w-full rounded-full border-2 border-secondary text-foreground transition-colors duration-300 hover:bg-secondary hover:text-secondary-foreground">
                    <Link to="https://wa.me/59896344395" newTab>WhatsApp</Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}